import { useMemo } from 'react';
import { useTranslation } from 'core/i18n/i18n';
import { useDeviceTypes } from 'core/contexts/device-types/hooks/use-device-types.hook';
import { OperatorCustomNotification } from 'modules/settings/pods/settings-operator-custom-notifications/operator-custom-notification.vm';
import { OperatorCustomNotificationRow } from 'modules/settings/pods/settings-operator-custom-notifications/settings-operator-custom-notifications.model';
import {
    buildOperatorCustomNotificationRowLabels,
    toOperatorCustomNotificationRow,
} from 'modules/settings/pods/settings-operator-custom-notifications/operator-custom-notification-rows.mapper';

export const useOperatorCustomNotificationRows = (
    notifications: OperatorCustomNotification[]
): OperatorCustomNotificationRow[] => {
    const { t } = useTranslation();
    const { deviceTypes } = useDeviceTypes();

    return useMemo(() => {
        const labels = buildOperatorCustomNotificationRowLabels(t);
        const resolveDeviceTypeName = (deviceTypeId: string) =>
            deviceTypes.find((deviceType) => deviceType.id === deviceTypeId)?.name;

        return notifications.map((notification) =>
            toOperatorCustomNotificationRow(notification, resolveDeviceTypeName, labels)
        );
    }, [notifications, t, deviceTypes]);
};
